import browserDetect from 'browser-detect';
import { SHA256, enc } from 'crypto-js';
import getContext from '../utilities/get-context';

const userData = getContext().__MA__.user;

const isGmail = email => /@gmail\.com$/.test(email);

const normalizeAndHashEmailAddress = (email) => {
  try {
    let normalizedEmail = email.toLowerCase().trim();
    const emailParts = normalizedEmail.split('@');
    if (emailParts.length && isGmail(email)) {
      normalizedEmail = `${emailParts[0].split('.').join('')}@${emailParts[1]}`;
    }
    const hashHex = SHA256(normalizedEmail);
    return hashHex.toString(enc.Hex);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Faield to hash email', err);
  }
};

export const getBasicUserData = ({ userId = userData.id, email = userData.email } = {}) => {
  const browserMeta = browserDetect();
  return {
    userId,
    operatingSystem: browserMeta.os,
    ...(email && {userEmail: normalizeAndHashEmailAddress(email)}),
    emailType: isGmail(email) ? 'gmail' : 'not-gmail',
    device: browserMeta.mobile ? 'Mobile' : 'Desktop',
    ...(email && { email }),
    ...(userData.country && { country: userData.country }),
  };
};
